import React from 'react';

const Health: React.FC = () => {
  return (
    <div className={'container'}>
      <div style={{ textAlign: 'center' }}>
        <h1>It&apos;s Healthy!</h1>
      </div>
    </div>
  );
};

export default Health;
